<template>
  <!-- 问诊室 -->
  <div class="keyong">
    <div class="top">
      <Input
        v-model.trim="searchValue"
        @on-clear="getselectQuestionByCondition"
        @on-enter="getselectQuestionByCondition"
        placeholder="搜索"
        class="journal-input"
        clearable
      >
        <Icon type="ios-search" slot="prefix" />
      </Input>
      <Button
        class="title-btn fourSize"
        type="success"
        @click="tonewAdd(1)"
        ghost
        >新增</Button
      >
      <Button
        class="title-btn fourSize"
        type="success"
        @click="tonewAdd(2)"
        ghost
        >导出</Button
      >
      <Button
        class="title-btn fourSize"
        type="success"
        @click="tonewAdd(3)"
        ghost
        >导入</Button
      >
    </div>

    <div class="bottom" v-show="list.length > 0">
      <Collapse v-model="value">
        <Panel v-for="(item, index) in list" :name="item.value" :key="index">
          {{ item.subjectNum }} : {{ item.topic }}
          <Button
            class="title-btn title-btns title-btns2"
            type="success"
            @click.stop="tonewAdds(item, index, 1)"
            ghost
            >修改</Button
          >
          <Button
            class="title-btn title-btns"
            type="success"
            @click.stop="tonewAdds(item, index, 2)"
            ghost
            >删除</Button
          >
          <div
            slot="content"
            v-show="item.listOption && item.listOption.length > 0"
          >
            <Collapse accordion v-model="item.index">
              <Panel
                :name="items.value"
                v-for="(items, indexs) in item.listOption"
                :key="indexs"
              >
                {{ items.choose }}
                <div
                  slot="content"
                  v-show="
                    items.pmsQuestionList && items.pmsQuestionList.length > 0
                  "
                >
                  <Collapse accordion v-model="items.index">
                    <Panel
                      :name="items2.index"
                      v-for="(items2, indexs2) in items.pmsQuestionList"
                      :key="indexs2"
                    >
                      {{ items2.subjectNum }} : {{ items2.topic }}
                      <Button
                        class="title-btn  title-btns title-btns2"
                        type="success"
                        @click.stop="tonewAdds(items2, index, 1)"
                        ghost
                        >修改</Button
                      >
                      <Button
                        class="title-btn  title-btns"
                        type="success"
                        @click.stop="tonewAdds(items2, index, 2)"
                        ghost
                        >删除</Button
                      >
                      <div
                        slot="content"
                        v-show="
                          items2.listOption && items2.listOption.length > 0
                        "
                      >
                        <Collapse>
                          <div
                            :class="[
                              b == items2.listOption.length - 1
                                ? 'daan daans'
                                : 'daan'
                            ]"
                            v-for="(a, b) in items2.listOption"
                            :key="b"
                          >
                            {{ a.choose }}
                          </div>
                        </Collapse>
                      </div>
                    </Panel>
                  </Collapse>
                </div>
              </Panel>
            </Collapse>
          </div>
        </Panel>
      </Collapse>
    </div>
    <div v-show="list.length == 0">
      <img class="kong-img" src="../img/kong.jpg" alt="" />
      <div class="kong-item">无相关搜索</div>
    </div>

    <Modal
      class="ivumodal"
      width="500"
      v-model="ishow"
      :title="addTitle"
      footer-hide
    >
      <div class="modal-cont">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="170"
        >
          <FormItem
            label="展示顺序："
            prop="subjectNum"
            class="bumenModal-item"
          >
            <Input
              v-model="formValidate.subjectNum"
              placeholder=""
              style="color:#7F7F7F"
            />
          </FormItem>
          <FormItem label="题型:" prop="types" class="bumenModal-item">
            <Select
              v-model="formValidate.types"
              placeholder="请选择"
              :label-in-value="true"
              style="color:#7F7F7F"
              @on-change="typeselect"
            >
              <Option value="单选题">单选题</Option>
              <Option value="多选题+描述题">多选题+描述题</Option>
            </Select>
          </FormItem>
          <FormItem label="题类名称：" prop="classify" class="bumenModal-item">
            <Input
              v-model="formValidate.classify"
              placeholder=""
              style="color:#7F7F7F"
            />
          </FormItem>
          <FormItem label="题目名称：" prop="topic" class="bumenModal-item">
            <Input
              v-model="formValidate.topic"
              placeholder=""
              style="color:#7F7F7F"
            />
          </FormItem>
          <FormItem
            label="上级题目："
            prop="upQuestionId"
            class="bumenModal-item"
          >
            <Select
              v-model="formValidate.upQuestionId"
              placeholder="无"
              :label-in-value="true"
              @on-change="selectChange"
              style="color:#7F7F7F"
            >
              <Option
                v-for="(item, index) in formValidate.upQuestionlist"
                :value="item.id + ''"
                :key="index"
                >{{ item.topic }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            label="上级题目选项："
            prop="upQuestionOptionId"
            class="bumenModal-item"
          >
            <Select
              v-model="formValidate.upQuestionOptionId"
              placeholder="无"
              :label-in-value="true"
              style="color:#7F7F7F"
            >
              <Option
                v-for="(item, index) in formValidate.upQuestionOptionList"
                :value="item.id + ''"
                :key="index"
                >{{ item.choose }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            label="上方说明文字："
            prop="topExplain"
            class="bumenModal-item"
          >
            <Input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 3 }"
              v-model="formValidate.topExplain"
              placeholder=""
              style="color:#7F7F7F"
            />
          </FormItem>
          <FormItem
            label="下方说明文字："
            prop="underExplain"
            class="bumenModal-item"
          >
            <Input
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 3 }"
              v-model="formValidate.underExplain"
              placeholder=""
              style="color:#7F7F7F"
            />
          </FormItem>
          <!-- chooseType -->
          <FormItem
            :rules="{
              required: true,
              message: '请您录入选项',
              trigger: 'blur'
            }"
            :label="index == 0 ? '题目内容：' : ''"
            :prop="'listOption.' + index + '.choose'"
            class="bumenModal-item"
            v-for="(item, index) in formValidate.listOption"
            :key="index"
          >
            <Select
              v-show="formValidate.type == 2"
              v-model="item.chooseType"
              :label-in-value="true"
              style="color:#7F7F7F"
            >
              <Option :value="1">多选选项</Option>
              <Option :value="2">描述标题</Option>
            </Select>
            <Input
              class="list-class"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 2 }"
              v-model="item.choose"
              placeholder="请您记录选项"
            />
            <Icon
              v-show="index !== 0"
              @click="slice(item, index)"
              class="i-icon"
              type="ios-remove-circle-outline"
            />
            <Icon
              v-show="index == 0"
              class="i-icon i-icons"
              type="ios-remove-circle-outline"
            />
            <Icon
              class="i-icon"
              @click="add(item, index)"
              type="ios-add-circle-outline"
            />
          </FormItem>
        </Form>
        <div class="secondBumen-bottom">
          <Button
            class="btn"
            type="success"
            ghost
            @click="formValidateReset('formValidate')"
            >取消</Button
          >
          <Button
            class="btn sure"
            type="success"
            ghost
            @click="formValidateSubmit('formValidate')"
            >确定</Button
          >
        </div>
      </div>
    </Modal>

    <Modal
      class="ivumodal"
      width="500"
      footer-hide
      v-model="errors"
      title="确认操作"
    >
      <div class="ivumodal-cont">
        此操作生效于本题及下级题目，确认删除？
      </div>
      <div class="secondBumen-bottom">
        <Button class="btn" type="success" ghost @click="ok()">取消</Button>
        <Button class="btn sure" type="success" ghost @click="ok(1)"
          >确定</Button
        >
      </div>
    </Modal>

    <Alert class="alertTitle" v-show="alertTitleIshow" show-icon type="success"
      >操作成功</Alert
    >
    <Alert
      class="alertTitle"
      v-show="alertTitleIshow2"
      type="error"
      show-icon
      >{{ alertTitle }}</Alert
    >
    <!-- <Spin fix v-show="isiconfontshow">
      <span class="iconfont demo-spin-icon-load ivu-icon">&#xe71d;</span>
      <div>距离有些遥远，小简 正在努力中……</div>
    </Spin> -->
  </div>
</template>
<script>
    import {
        selectQuestionByCondition,
        selectUpParent,
        modifyQuestion,
        addQuestion,
        deleteQuestion
    } from "../servers/api";
    import {
        stringify
    } from "querystring";
    export default {
        name: "canxiang",
        data() {
            return {
                alertTitle: "",
                alertTitleIshow2: false,
                alertTitleIshow: false,
                isiconfontshow: false,
                errors: false,
                ishow: false,
                accordion: false,
                list: [{
                    index: "",
                    name: " 你目前吸烟吗",
                    lists: [{
                        a: "吸烟",
                        index: "1-1",
                        lists2: [{
                            name: "吸烟-哈哈",
                            list: [{
                                name: "答案1",
                                index: ""
                            }, {
                                name: "答案1",
                                index: ""
                            }],
                            value: ""
                        }, {
                            name: "吸烟-哈哈",
                            list: [{
                                name: "答案2",
                                index: ""
                            }, {
                                name: "答案2",
                                index: ""
                            }],
                            value: ""
                        }, {
                            name: "吸烟-哈哈",
                            list: [{
                                name: "答案3",
                                index: ""
                            }, {
                                name: "答案3",
                                index: ""
                            }],
                            value: ""
                        }],
                        value: ""
                    }, {
                        a: "不吸烟",
                        index: "1-2",
                        value: "",
                        lists2: []
                    }],
                    value: ""
                }, {
                    index: "",
                    name: " 乔纳森·伊夫2",
                    value: ""
                }],
                addTitle: "新增题目",
                aaa: [{
                    value: "1"
                }, {
                    value: "2"
                }],
                isiconfontshow: false,
                alertTitleIshow: false,
                alertTitleIshow2: false,
                alertTitle: "",
                searchValue: "",
                value: "",
                formValidate: {
                    types: "单选题",
                    upQuestionlist: [],
                    upQuestionOptionList: [],
                    upQuestionId: "",
                    upQuestionOptionId: "",
                    listOption: [{
                        chooseType: 1,
                        choose: ""
                    }]
                },
                ruleValidate: {
                    subjectNum: [
                        //change
                        {
                            required: true,
                            message: "请输入展示顺序",
                            trigger: "blur"
                        }
                    ],
                    types: [
                        //change
                        {
                            required: true,
                            message: "请输入展示顺序",
                            trigger: "blur"
                        }
                    ],
                    topic: [
                        //change
                        {
                            required: true,
                            message: "请输入题目名称",
                            trigger: "blur"
                        }
                    ],
                    upQuestionId: [
                        //change
                        {
                            required: true,
                            message: "请选择上级题目",
                            trigger: "change"
                        }
                    ],
                    upQuestionOptionId: [
                        //change
                        {
                            required: true,
                            message: "请选择上级题目选项",
                            trigger: "change"
                        }
                    ],
                    classify: [
                        //change
                        {
                            required: true,
                            message: "请输入题类名称",
                            trigger: "blur"
                        }
                    ]
                },
                errorsObj: {}
            };
        },
        methods: {
            selectChange(name) {
                //上级题目select
                if (name) {
                    for (let i = 0; i < this.formValidate.upQuestionlist.length; i++) {
                        if (this.formValidate.upQuestionlist[i].id == name.value) {
                            this.formValidate.upQuestionOptionList =
                                this.formValidate.upQuestionlist[i].listOption || [];
                        }
                    }
                }
            },
            deepCopy(obj) {
                var result = Array.isArray(obj) ? [] : {};
                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        if (typeof obj[key] === "object" && obj[key] !== null) {
                            result[key] = this.deepCopy(obj[key]); //递归复制
                        } else {
                            result[key] = obj[key];
                        }
                    }
                }
                return result;
            },
            tonewAdds(item, index, num) {
                //删除和修改
                if (num == 1) {
                    //修改
                    console.log(item);
                    this.isiconfontshow = true;
                    this.addTitle = "修改题目";
                    this.formValidate = this.deepCopy(item);
                    if (!this.formValidate.upQuestionId ||
                        this.formValidate.upQuestionId == ""
                    ) {
                        this.formValidate.upQuestionId = "无";
                    }
                    if (!this.formValidate.upQuestionOptionId ||
                        this.formValidate.upQuestionOptionId == ""
                    ) {
                        this.formValidate.upQuestionOptionId = "无";
                    }
                    if (this.formValidate.type == 1) {
                        this.formValidate.types = "单选题";
                    } else {
                        this.formValidate.types = "多选题+描述题";
                        for (let i = 0; i < this.formValidate.listOption.length; i++) {
                            if (this.formValidate.listOption[i].chooseType == 1) {}
                        }
                    }
                    this.formValidate.subjectNum = this.formValidate.subjectNum + "";
                    selectUpParent({
                        questionId: this.formValidate.id
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.formValidate.upQuestionlist = res.data.data || [];
                            if (!this.formValidate.upQuestionNam) {
                                this.formValidate.upQuestionNam = "无";
                            }
                            this.selectChange({
                                value: this.formValidate.upQuestionId
                            });
                            this.ishow = true;
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                } else {
                    //删除
                    this.errorsObj = {};
                    this.errors = true;
                    this.errorsObj = item;
                }
            },
            tonewAdd(index) {
                //点击按钮
                if (index == 1) {
                    //新增
                    this.isiconfontshow = true;
                    this.addTitle = "新增题目";
                    this.formValidateReset("formValidate");
                    (this.formValidate = {
                        types: "单选题",
                        upQuestionlist: [],
                        upQuestionOptionList: [],
                        upQuestionId: "无",
                        upQuestionOptionId: "无",
                        listOption: [{
                            chooseType: 1,
                            choose: ""
                        }],
                        upQuestionOptionList: [{
                            choose: "无"
                        }]
                    }),
                    selectUpParent({
                        questionId: ""
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.formValidate.upQuestionlist = res.data.data || [];
                            if (!this.formValidate.upQuestionNam) {
                                this.formValidate.upQuestionNam = "无";
                            }
                            this.ishow = true;
                        } else {}
                    });
                }
            },
            formValidateReset(name) {
                //弹窗 取消
                this.$refs[name].resetFields();
                this.ishow = false;
            },
            formValidateSubmit(name) {
                //弹窗 确定
                this.typeselect();
                this.$refs[name].validate(valid => {
                    if (valid) {
                        if (this.addTitle == "修改题目") {
                            this.isiconfontshow = true;
                            let params = {
                                questionId: this.formValidate.id,
                                classify: this.formValidate.classify,
                                type: this.formValidate.type,
                                topic: this.formValidate.topic,
                                underExplain: this.formValidate.underExplain,
                                upQuestionId: this.formValidate.upQuestionId,
                                upQuestionOptionId: this.formValidate.upQuestionOptionId,
                                subjectNum: this.formValidate.subjectNum,
                                optionList: JSON.stringify(this.formValidate.listOption),
                                topExplain: this.formValidate.topExplain
                            };
                            modifyQuestion(params).then(res => {
                                if (res.data.code == 1) {
                                    this.isiconfontshow = false;
                                    this.ishow = false;
                                    this.alertTitleIshow = true;
                                    setTimeout(() => {
                                        this.alertTitleIshow = false;
                                    }, 2000);
                                    this.getselectQuestionByCondition();
                                } else {
                                    this.isiconfontshow = false;
                                    this.alertTitle = res.data.msg;
                                    this.alertTitleIshow2 = true;
                                    setTimeout(() => {
                                        this.alertTitleIshow2 = false;
                                    }, 2000);
                                }
                            });
                        } else {
                            this.isiconfontshow = true;
                            let params = {
                                classify: this.formValidate.classify,
                                type: this.formValidate.type,
                                topic: this.formValidate.topic,
                                underExplain: this.formValidate.underExplain,
                                upQuestionId: this.formValidate.upQuestionId,
                                upQuestionOptionId: this.formValidate.upQuestionOptionId,
                                subjectNum: this.formValidate.subjectNum,
                                optionList: JSON.stringify(this.formValidate.listOption),
                                topExplain: this.formValidate.topExplain
                            };
                            addQuestion(params).then(res => {
                                if (res.data.code == 1) {
                                    this.isiconfontshow = false;
                                    this.ishow = false;
                                    this.alertTitleIshow = true;
                                    setTimeout(() => {
                                        this.alertTitleIshow = false;
                                    }, 2000);
                                    this.getselectQuestionByCondition();
                                } else {
                                    this.isiconfontshow = false;
                                    this.alertTitle = res.data.msg;
                                    this.alertTitleIshow2 = true;
                                    setTimeout(() => {
                                        this.alertTitleIshow2 = false;
                                    }, 2000);
                                }
                            });
                        }
                    }
                });
            },
            getselectQuestionByCondition() {
                //列表接口
                this.isiconfontshow = true;
                selectQuestionByCondition({
                    topic: this.searchValue
                }).then(res => {
                    if (res.data.code == 1) {
                        this.isiconfontshow = false;
                        this.list = res.data.data || [];
                        for (let i = 0; i < this.list.length; i++) {
                            this.list[i].value = i + 1 + "";
                            if (this.list[i].listOption && this.list[i].listOption.length > 0) {
                                for (let j = 0; j < this.list[i].listOption.length; j++) {
                                    this.list[i].listOption[j].value = j + 1 + "";
                                }
                            }
                        }
                    } else {
                        this.isiconfontshow = false;
                        this.alertTitle = res.data.msg;
                        this.alertTitleIshow2 = true;
                        setTimeout(() => {
                            this.alertTitleIshow2 = false;
                        }, 2000);
                    }
                });
            },
            ok(index) {
                if (index) {
                    //删除
                    this.isiconfontshow = true;
                    let params = {
                        questionId: this.errorsObj.id,
                        type: this.errorsObj.type,
                        upQuestionId: this.errorsObj.upQuestionId,
                        upQuestionOptionId: this.errorsObj.upQuestionOptionId,
                        isParent: this.errorsObj.isParent
                    };
                    deleteQuestion(params).then(res => {
                        if (res.data.code == 1) {
                            this.isiconfontshow = false;
                            this.errors = false;
                            this.alertTitleIshow = true;
                            setTimeout(() => {
                                this.alertTitleIshow = false;
                            }, 2000);
                            this.getselectQuestionByCondition();
                        } else {
                            this.isiconfontshow = false;
                            this.alertTitle = res.data.msg;
                            this.alertTitleIshow2 = true;
                            setTimeout(() => {
                                this.alertTitleIshow2 = false;
                            }, 2000);
                        }
                    });
                } else {
                    this.errors = false;
                }
            },
            typeselect(name) {
                //type得select
                if (this.formValidate.types == "单选题") {
                    this.formValidate.type = "1";
                } else {
                    this.formValidate.type = "2";
                }
            },
            slice(item, index) {
                //删除
                this.formValidate.listOption.splice(index, 1);
            },
            add(item, index) {
                //添加
                this.formValidate.listOption.push({
                    chooseType: 1,
                    choose: ""
                });
            }
        },
        created() {
            this.getselectQuestionByCondition();
        },
        components: {}
    };
</script>
<style lang="scss" scoped="" type="text/css">
    @import "../css/conmmon.scss";
    @import "../font/iconfont.css";
    .bumenModal-item {
        margin-top: 15px;
    }
    
    .ivumodal /deep/ {
        .ivu-form-item-error-tip {
            padding: 0 !important;
        }
    }
    
    .list-class {
        color: #7f7f7f;
        width: 160px;
        display: inline-block;
        vertical-align: middle;
    }
    
    .modal-cont {
        height: 550px;
        padding-right: 15px;
        overflow: hidden;
        overflow-y: visible;
    }
    
    .kong-img {
        width: 300px;
        height: 220px;
        margin: 30px auto;
        display: block;
    }
    
    .kong-item {
        font-size: 13px;
        text-align: center;
        width: 100%;
        margin-top: 20px;
    }
    
    .ivu-collapse {
        border-color: #53cac3;
        color: #7f7f7f;
    }
    
    .ivu-collapse /deep/ {
        .ivu-collapse-header {
            color: #7f7f7f;
            background: #fff;
        }
    }
    
    .daan {
        height: 38px;
        line-height: 38px;
        padding-left: 16px;
        border-bottom: 1px solid #53cac3;
        background: #fff;
        color: #7f7f7f;
    }
    
    .ivu-collapse /deep/ .ivu-collapse-content {
        border-color: #53cac3;
        color: #7f7f7f;
    }
    
    .ivu-collapse-content,
    .ivu-collapse-item,
    .ivu-collapse-header {
        border-color: #53cac3;
        color: #7f7f7f;
    }
    
    .ivu-collapse /deep/ .ivu-collapse-item-active>.ivu-collapse-header {
        border-color: #53cac3;
        color: #7f7f7f;
    }
    
    .ivu-collapse {
        border-color: #53cac3;
    }
    
    .daans {
        border: none;
    }
    
    .keyong {
        padding: 15px;
        font-size: 13px;
        height: 100%;
        width: 100%;
        overflow: hidden;
        overflow-y: scroll;
        overflow-y: visible;
        color: #7f7f7f;
        .journal-input {
            width: 250px;
        }
        .top {
            width: calc(100% - 250px);
            height: 60px;
            line-height: 35px;
            position: fixed;
            top: 111px;
            z-index: 99;
            background: #fff;
            padding-top: 17px;
            left: 220px;
            padding-left: 15px;
            padding-bottom: 15px;
        }
        .title-btn {
            float: right;
            margin-left: 10px;
        }
        .bottom {
            padding: 15px 0;
            margin: 40px 0 20px;
        }
        .title-btns {
            margin-top: 5px;
            width: 50px;
            text-align: center;
            padding: 5px 10px 6px;
        }
        .title-btns2 {
            margin-right: 15px;
        }
    }
    
    .i-icon {
        font-size: 25px;
        font-weight: 700;
        line-height: 30px;
        vertical-align: middle;
        color: #53cac3;
        margin-left: 15px;
        cursor: pointer;
    }
    
    .i-icons {
        color: #fff;
    }
</style>


// WEBPACK FOOTER //
// src/components/wenzhen/wenzhen.vue